import {
  useLinkToolbarButton,
  useLinkToolbarButtonState,
} from "@platejs/link/react";
import LinkIcon from "@redotech/redo-icons/link-01_filled.svg";
import { memo } from "react";
import { RedoIcon } from "../../arbiter-components/icon/redo-icon";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import { ToolbarButton } from "./toolbar";
import { useToolbarOverflow } from "./toolbar-overflow";

export const LinkToolbarButton = memo(function LinkToolbarButton() {
  const state = useLinkToolbarButtonState();
  const { props: buttonProps } = useLinkToolbarButton(state);
  const { isOverflow } = useToolbarOverflow();

  if (isOverflow) {
    return (
      <DropdownMenuItem onSelect={buttonProps.onClick as () => void}>
        <RedoIcon Icon={LinkIcon} size={16} />
        Link
      </DropdownMenuItem>
    );
  }

  return (
    <ToolbarButton
      Icon={LinkIcon}
      onClick={buttonProps.onClick}
      pressed={buttonProps.pressed}
      tooltip="Link"
    />
  );
});
